import {
    UPDATE_PROPERTY_INPUT,
    UPDATE_PROPERTY_INPUT_BULK,
    REQUEST_PROPERTY_CALC,
    RECEIVE_PROPERTY_CALC,
    UI_TOGGLE_BOOLEAN,
    CHANGE_WIZARD_STEP
} from "./PropertyActionTypes";

const initialState = {
    // Questions:
    purchasePrice: 0,
    deposit: 0,
    costsRefurbishment: 0,
    income: 0,
    costsMonthlyManagement: 0,
    costsMonthlyBills: 0,
    costsMonthlyOther: 0,
    interestRate: 3.6,
    otherBuyingFees: 0,
    propertyName: '',
    nonPropertyEarnings: 50000,
    nonPropertyDividendIncome: 0,
    purchaseLimited: false,

    // Calculated server-side:
    stampDuty: 0,
    purchaseCostsTotal: 0,
    purchaseCashRequired: 0,
    yieldGross: 0,
    yieldNet: 0,
    costsAnnualTotal: 0,
    incomeNetBeforeInterest: 0,
    incomeNet: 0,
    interest: 0,
    interestCoverRatio: 0,
    mortgageBalance: 0,
    roi: 0,
    ltv: 0,
    growthCapitalTotal: 0,
    growthProfitTotal: 0,
    growthCapitalByYear: [],

    over150k: false,

    taxProjectionPersonal: {
        year: 2019,
        grossProfit: 0,
        corporationTax: 0,
        incomeTax: 0,
        taxTotal: 0,
        netProfitRetained: 0,
        netProfitReturned: 0,
        additionalAnnualInvestment: 0,
        retainedTotal: 0
    },

    taxProjectionSPV: {
        year: 2019,
        grossProfit: 0,
        corporationTax: 0,
        incomeTax: 0,
        taxTotal: 0,
        netProfitRetained: 0,
        netProfitReturned: 0,
        additionalAnnualInvestment: 0,
        retainedTotal: 0
    },

    // State
    isFetching: false,
    isStale: false,      // i.e. needs fetching

    //UI States
    // TODO Ben - should these be true for collapsed
    UICollapseCashRequired: false,
    UICollapseGrossProfit: false,
    UICollapsePropertyReport: false,
    UICollapseMortgageDetails: false,
    UICollapseTaxPersonal: false,
    UICollapseTaxSPV: false,
    currentWizardStepIndex: 0,
    showReport: false,

    //Goal questions
    goal: 'retain',     // retain, nextProperty, income
    projectionYears: 15,
    profitGoal: 30000,
    additionalAnnualInvestment: 0

};

export const PROPERTY_INPUT_KEYS = [
    'purchasePrice', 'deposit', 'costsRefurbishment', 'income', 'costsMonthlyManagement', 
    'costsMonthlyBills', 'costsMonthlyOther', 'interestRate', 'otherBuyingFees', 'propertyName',
    'goal', 'projectionYears', 'profitGoal', 'additionalAnnualInvestment', 
    'nonPropertyEarnings', 'nonPropertyDividendIncome', 'purchaseLimited'];
export const UI_TOGGLE_BOOLEAN_OPTIONS = ['UICollapseCashRequired', 'UICollapseGrossProfit', 'UICollapsePropertyReport', 'showReport', 'UICollapseMortgageDetails', 'UICollapseTaxPersonal', 'UICollapseTaxSPV'];

export default function (state = initialState, action) {
    switch (action.type) {
        case UPDATE_PROPERTY_INPUT: {
            if (!PROPERTY_INPUT_KEYS.includes(action.key)) {
                console.log("Denied updating of key: " + action.key);
                return state;
            };
            return {
                ...state,
                [action.key]: action.value,
                isStale : action.key !== 'propertyName' ? true : false
            };
        }
        case UPDATE_PROPERTY_INPUT_BULK: {
            return {
                ...state,
                ...action.values,
                isStale: true
            }
        }
        case REQUEST_PROPERTY_CALC:
            return Object.assign({}, state, {
                isFetching: true,
                isStale: false
            });
        case RECEIVE_PROPERTY_CALC:
            return Object.assign({}, state, {
                ...action.calc.propertyCalculation,
                taxProjectionPersonal: action.calc.taxProjectionPersonal,
                taxProjectionSPV: action.calc.taxProjectionSPV,
                over150k: action.calc.over150k,
                isFetching: false,
                isStale: false,
                lastUpdated: action.receivedAt
            });
        case UI_TOGGLE_BOOLEAN: {
            if (!UI_TOGGLE_BOOLEAN_OPTIONS.includes(action.key)) {
                console.log("Denied updating of key: " + action.key);
                return state;
            }
            return {
                ...state,
                [action.key]: !state[action.key]
            };
        }
        case CHANGE_WIZARD_STEP: {
            return {
                ...state,
                currentWizardStepIndex: action.step
            };

        }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/Features/PropertyCalculator/PropertyReducers.jsx